import { combineReducers } from "redux";
import { storeData } from "./storeData";

export const reducers = combineReducers({
  storeData,
});
